import { MappingInfo, TargetField } from './../interfaces/Mapping';
import axios from 'axios';

const BATCH_MAPPINGS_URL = '/api/v1/batch/mappings';
const BATCH_TARGETS_URL = '/api/v1/batch/targets';

interface MappingResponse {
	data: any;
	status: number;
	success: boolean;
}

export const MappingApi = {
	async getMappingTemplateInfo(mappingId: string = ''): Promise<MappingInfo[]> {
		return await axios
			.get(`${BATCH_MAPPINGS_URL}/${mappingId}`)
			.then(response => response.data.data.content)
			.catch(err => {
				console.error(err);
				throw err;
			});
	},
	async getTargetFields(calculationType: number): Promise<TargetField[]> {
		return axios
			.get(`${BATCH_TARGETS_URL}?calculation_type=${calculationType}`)
			.then(response => response.data.data)
			.catch(err => {
				console.error(err);
				throw err;
			});
	},

	async saveMappedColumns(
		calculationType: number,
		mappedColumns: MappingInfo[],
		scope?: string
	): Promise<MappingResponse> {
		return axios
			.post(`${BATCH_MAPPINGS_URL}?calculation_type=${calculationType}`, {
				scope,
				content: mappedColumns,
			})
			.then(response => response.data)
			.catch(err => {
				console.error(err);
				throw err;
			});
	},
	async updateMappedColumns(mappingId: string, calculationType: number, mappedColumns: MappingInfo[], scope: string) {
		return axios
			.put(`${BATCH_MAPPINGS_URL}/${mappingId}?calculation_type=${calculationType}`, {
				content: mappedColumns,
				scope,
			})
			.then(response => response)
			.catch(err => {
				console.error(err);
				throw err;
			});
	},
};
